import React from 'react';

import { InboxContext } from './InboxContext';

export const useInboxContext = () => {
  return React.useContext(InboxContext);
};
